import React from "react";
import { Link } from "react-router-dom";
import { Phone, Star, Award, Landmark } from "lucide-react";
import { BUSINESS, UI, trackEvent } from "@/content/site";
import { useGoogleRating, googleChipLabel } from "@/hooks/useGoogleRating";
import "./hero.css";

export default function Hero({ page, lang }) {
  const ui = UI[lang];
  // [Phase 26] Live Google chip in the hero trust list (see TrustBar).
  const live = useGoogleRating(lang);
  return (
    <section className="gw-hero">
      <div className="gw-container gw-hero-inner">
        <div className="gw-hero-content">
          <span className="gw-eyebrow">{page.hero_kicker || page.h1}</span>
          <h1 className="gw-hero-h1">{page.h1}</h1>
          {page.hero_subhead && <p className="gw-hero-subhead">{page.hero_subhead}</p>}
          {page.hero_intro && <p className="gw-hero-intro">{page.hero_intro}</p>}
          <div className="gw-hero-cta">
            <Link
              to={ui.contactUrl}
              className="gw-btn gw-btn-primary gw-btn-lg"
              onClick={() => trackEvent("cta_click", { location: "hero", label: "consultation" })}
              data-testid="hero-consultation-cta"
            >
              {ui.ctaConsultation}
            </Link>
            <a
              href={`tel:${BUSINESS.phoneTel}`}
              className="gw-btn gw-btn-accent gw-btn-lg"
              onClick={() => trackEvent("phone_click", { location: "hero" })}
              data-testid="hero-call-cta"
            >
              <Phone size={18} strokeWidth={2.2} aria-hidden="true" /> {ui.ctaCall}
            </a>
          </div>
          <ul className="gw-hero-trust">
            <li data-testid="hero-google-chip"><Star size={16} strokeWidth={2} aria-hidden="true" /> {googleChipLabel(live, lang, ui.trustGoogle)}</li>
            <li><Award size={16} strokeWidth={2} aria-hidden="true" /> {ui.trustSuperLawyers}</li>
            <li><Landmark size={16} strokeWidth={2} aria-hidden="true" /> {ui.trustBilingual}</li>
          </ul>
        </div>
        <div className="gw-hero-visual">
          <div className="gw-hero-portrait">
            <div className="gw-portrait-frame">
              <img
                src="/images/isabela-hero.jpeg"
                alt={lang === "en"
                  ? "Isabela A. Garcia, founding attorney of Garcia-Windsor, P.C., bilingual Dallas family law lawyer"
                  : "Isabela A. García, abogada fundadora de Garcia-Windsor, P.C., abogada bilingüe de derecho familiar en Dallas"}
                className="gw-portrait-img"
                width="420"
                height="520"
                loading="eager"
                fetchPriority="high"
                data-testid="hero-attorney-portrait"
              />
            </div>
            <div className="gw-portrait-caption">
              <strong>Isabela A. Garcia</strong>
              <em>{lang === "en" ? "Founding Attorney · Bilingual" : "Abogada Fundadora · Bilingüe"}</em>
              <span className="gw-portrait-badge">{lang === "en" ? "Mexican Consulate Consulting Attorney" : "Abogada Consultora del Consulado"}</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
